import { useEffect, useMemo, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import useProject from "@/hooks/useProject";
import { ROLES, PORTAL_ROLES, projectPath } from "@/lib/roles";
import Navbar from "@/components/Navbar";
import ProjectRoadmap from "@/components/ProjectRoadmap";
import MoriAIChat from "@/components/MoriAIChat";
import LoadingScreen from "@/components/LoadingScreen";
import NoAccess from "@/pages/NoAccess";
import HokusaiDecor from "@/components/HokusaiDecor";

export default function PortalProject() {
  const { role, projectId } = useParams();
  const { project, tasks, setTasks, phases, loading, error, refreshProject } = useProject(projectId);
  const [selectedId, setSelectedId] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    if (phases.length && !selectedId) setSelectedId(phases[0].id);
  }, [phases, selectedId]);

  const activePhase = useMemo(() => phases.find((p) => p.id === selectedId), [phases, selectedId]);

  if (!PORTAL_ROLES.includes(role)) return <Navigate to="/" replace />;
  if (loading) return <LoadingScreen text="Cargando el proyecto…" />;
  if (error || !project) return <NoAccess title="No tienes acceso a este proyecto" backTo={ROLES[role].path} />;
  if (project.my_role !== role) return <Navigate to={projectPath(project.my_role, projectId)} replace />;

  return (
    <div className="relative min-h-screen bg-background" data-testid={`portal-project-${role}`}>
      <HokusaiDecor />
      <Navbar
        backTo={ROLES[role].path}
        title={project.name}
        subtitle="Hoja de ruta"
        roleLabel={ROLES[role].label}
        globalPercent={project.progress?.global_percent}
        onOpenChat={() => setChatOpen(true)}
        cover={project.cover_path}
      />
      <main className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ProjectRoadmap
          project={project}
          tasks={tasks}
          setTasks={setTasks}
          phases={phases}
          refreshProject={refreshProject}
          canEdit={role === "colaborador"}
          selectedId={selectedId}
          onSelect={setSelectedId}
        />
      </main>
      <MoriAIChat open={chatOpen} onOpenChange={setChatOpen} activePhase={activePhase} projectId={projectId} />
    </div>
  );
}
